import { AddAccountGroupsApi } from "@/features/accounts/account-group/services/add-account-groups-api";
import { AddAccountGroupsRequestModel } from "@/features/accounts/account-group/services/add-account-groups-model";

/// 口座グループ追加
export class AddAccountGroupsService {
  private addAccountGroupsApi = new AddAccountGroupsApi();

  /**
   * 口座グループ一覧取得
   */
  public async addAccountGroups(param: AddAccountGroupsRequestModel) {
    return await this.addAccountGroupsApi.addAccountGroup(param);
  }
}

